"use client";
import { useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";

export default function Login11() {
  const [open, setOpen] = useState(false);

  // Logo component that can be easily customized
  const Logo = () => (
    <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-primary">
      <div className="h-9 w-9 rounded-full bg-white"></div>
    </div>
  );

  const LoginForm = () => (
    <div className="flex w-full flex-col">
      <div className="flex flex-col items-center px-8 pt-8">
        <Logo />
        <h1 className="mb-1 mt-3 text-center text-[28px] font-bold text-foreground">
          Sign in to Acme Co
        </h1>
        <p className="mb-8 text-center text-[17px] text-muted-foreground">
          Welcome back! Please sign in to continue
        </p>
        <div className="mb-5 grid w-full grid-cols-3 gap-3">
          <Button variant="outline" className="h-[40px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
              <path d="M1 1h22v22H1z" fill="none" />
            </svg>
          </Button>
          <Button variant="outline" className="h-[40px]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12.073C24 5.446 18.627 0.073 12 0.073C5.373 0.073 0 5.446 0 12.073C0 18.063 4.388 23.027 10.125 23.927V15.542H7.078V12.072H10.125V9.43C10.125 6.423 11.917 4.761 14.658 4.761C15.97 4.761 17.344 4.996 17.344 4.996V7.949H15.83C14.34 7.949 13.875 8.874 13.875 9.823V12.073H17.203L16.671 15.543H13.875V23.928C19.612 23.027 24 18.064 24 12.073Z"
                fill="#1877F2"
              />
            </svg>
          </Button>
          <Button variant="outline" className="h-[40px]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0C5.37 0 0 5.37 0 12C0 17.31 3.435 21.795 8.205 23.385C8.805 23.49 9.03 23.13 9.03 22.815C9.03 22.53 9.015 21.585 9.015 20.58C6 21.135 5.22 19.845 4.98 19.17C4.845 18.825 4.26 17.76 3.75 17.475C3.33 17.25 2.73 16.695 3.735 16.68C4.68 16.665 5.355 17.55 5.58 17.91C6.66 19.725 8.385 19.215 9.075 18.9C9.18 18.12 9.495 17.595 9.84 17.295C7.17 16.995 4.38 15.96 4.38 11.37C4.38 10.065 4.845 8.985 5.61 8.145C5.49 7.845 5.07 6.615 5.73 4.965C5.73 4.965 6.735 4.65 9.03 6.195C9.99 5.925 11.01 5.79 12.03 5.79C13.05 5.79 14.07 5.925 15.03 6.195C17.325 4.635 18.33 4.965 18.33 4.965C18.99 6.615 18.57 7.845 18.45 8.145C19.215 8.985 19.68 10.05 19.68 11.37C19.68 15.975 16.875 16.995 14.205 17.295C14.64 17.67 15.015 18.39 15.015 19.515C15.015 21.12 15 22.41 15 22.815C15 23.13 15.225 23.505 15.825 23.385C18.2072 22.5807 20.2772 21.0497 21.7437 19.0074C23.2101 16.965 23.9993 14.5143 24 12C24 5.37 18.63 0 12 0Z"
              />
            </svg>
          </Button>
        </div>
        <div className="relative mb-4 w-full">
          <Separator className="absolute top-1/2 w-full" />
          <div className="relative flex justify-center">
            <span className="bg-background px-4 text-[15px] text-muted-foreground">
              or
            </span>
          </div>
        </div>
        <div className="mb-6 w-full space-y-4">
          <form className="space-y-8">
            <div className="grid gap-4">
              <Label htmlFor="email">Email address</Label>
              <Input id="email" type="email" placeholder="johndoe@mail.com" />
              <Button type="submit" className="w-full">
                Sign In with Email
              </Button>
            </div>
          </form>
        </div>
      </div>

      <div className="bg-muted py-3 text-center text-[15px] text-muted-foreground rounded-b-lg">
        Don&apos;t have an account?{" "}
        <Link href="#" className="font-medium text-foreground hover:underline">
          Sign up
        </Link>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button variant="default" size="lg">
            Sign In
          </Button>
        </DialogTrigger>
        <DialogTitle className="sr-only"></DialogTitle>
        <DialogContent className="p-0 border-none sm:max-w-md">
          <LoginForm />
        </DialogContent>
      </Dialog>
    </div>
  );
}
